import React from "react";
import { 
    FacebookShareButton, 
    TwitterShareButton, 
    LinkedinShareButton, 
    RedditShareButton, 
    WhatsappShareButton, 
    TelegramShareButton 
} from "react-share";
import { 
    FaFacebookF, 
    FaTwitter, 
    FaLinkedinIn, 
    FaRedditAlien,
    FaWhatsapp,
    FaTelegramPlane 
} from "react-icons/fa";
import footer from "../../constants/footer";

const { BLEND_URL } = footer;

const ShareSocialNetwork = () => {
  return (
    <div className="flex justify-center items-center lg:justify-between p-6 border-b border-gray-300">
      <div className="mr-12 hidden lg:block">
        <span className="font-semibold">Share us on social networks:</span>
      </div>
      <div className="flex justify-center">
        <FacebookShareButton
            url={BLEND_URL}
            className="mr-4"
        >   
            <FaFacebookF className="w-4 h-4 text-black" />
        </FacebookShareButton>
        <TwitterShareButton
            url={BLEND_URL}
            className="mr-4"
        >
            <FaTwitter className="w-4 h-4 text-black" />
        </TwitterShareButton>
        <LinkedinShareButton
            url={BLEND_URL}
            className="mr-4"
        >
            <FaLinkedinIn className="w-4 h-4 text-black" />
        </LinkedinShareButton>
        <RedditShareButton
            url={BLEND_URL}
            className="mr-4"
        >
            <FaRedditAlien className="w-4 h-4 text-black" />
        </RedditShareButton>
        <WhatsappShareButton
            url={BLEND_URL}
            className="mr-4"
        >
            <FaWhatsapp className="w-4 h-4 text-black" />
        </WhatsappShareButton>
        <TelegramShareButton
            url={BLEND_URL}
            className="mr-4 mt-1"
        >
            <FaTelegramPlane className="w-4 h-4 text-black" />
        </TelegramShareButton>
      </div>
    </div>
  );
};

export default ShareSocialNetwork;
